export default "__VITE_ASSET__D1t98oKA__"